(() => {
  if (window.SleekJourney) return;
  const storageKey = 'sleek_journey_session_v1';
  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'creative_variant', 'journey', 'offer'];
  const page = document.querySelector('[data-sleek-journey]');
  const context = {
    journey: page?.dataset.sleekJourney || (location.pathname === '/' ? 'furniture-home' : 'store'),
    page_version: page?.dataset.sleekPageVersion || 'recovery-v1',
    page_path: location.pathname,
    product_id: page?.dataset.sleekProductId || ''
  };
  let attribution = null;
  let pagePublished = false;
  const privacy = () => window.Shopify?.customerPrivacy;
  const analyticsAllowed = () => privacy()?.analyticsProcessingAllowed?.() === true;
  const marketingAllowed = () => privacy()?.marketingAllowed?.() === true;
  const clean = value => /^[a-zA-Z0-9_ .:/{}-]{1,160}$/.test(value || '') ? value : '';
  const contactForms = () => Array.from(document.querySelectorAll('form')).filter(form => form.querySelector('[name="form_type"]')?.value === 'contact');
  const publish = (name, extra = {}) => {
    if (!analyticsAllowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
    const source = marketingAllowed() && attribution ? attribution.last : {};
    try {
      Promise.resolve(window.Shopify.analytics.publish(`sleek:${name}`, { ...context, ...source, ...extra })).catch(() => {});
      return true;
    } catch { return false; }
  };
  const clear = () => {
    attribution = null;
    try { sessionStorage.removeItem(storageKey); } catch {}
    document.querySelectorAll('[data-sleek-attribution-field]').forEach(input => input.remove());
  };
  const sourceFields = form => {
    form.querySelectorAll('[data-sleek-attribution-field]').forEach(input => input.remove());
    if (!marketingAllowed() || !attribution) return;
    const fields = { ...attribution.last, landing_path: attribution.landing_path, journey_page: context.page_path, page_version: context.page_version };
    attributionKeys.forEach(key => { if (attribution.first[key]) fields[`first_${key}`] = attribution.first[key]; });
    Object.entries(fields).forEach(([key, value]) => {
      if (!value) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = `contact[${key}]`; input.value = value;
      input.dataset.sleekAttributionField = 'true'; form.appendChild(input);
    });
  };
  const sync = () => {
    if (!marketingAllowed()) clear();
    else {
      const current = {};
      const params = new URLSearchParams(location.search);
      attributionKeys.forEach(key => { const value = clean(params.get(key)); if (value) current[key] = value; });
      try { attribution = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch { attribution = null; }
      if (!attribution || !attribution.first || !attribution.last || typeof attribution.first !== 'object' || typeof attribution.last !== 'object') attribution = { first: current, last: current, landing_path: location.pathname };
      attribution.first = Object.fromEntries(attributionKeys.filter(key => clean(attribution.first[key])).map(key => [key, clean(attribution.first[key])]));
      attribution.last = Object.fromEntries(attributionKeys.filter(key => clean(attribution.last[key])).map(key => [key, clean(attribution.last[key])]));
      if (Object.keys(current).length) {
        if (!Object.keys(attribution.first).length) attribution.first = current;
        attribution.last = current;
      }
      try { sessionStorage.setItem(storageKey, JSON.stringify(attribution)); } catch {}
      contactForms().forEach(sourceFields);
    }
    if (!pagePublished) pagePublished = publish('journey_view');
    document.querySelectorAll('[data-sleek-lead-confirmed]').forEach(node => {
      if (node.dataset.sleekReported === 'true') return;
      if (publish('project_request_confirmed', { journey: node.dataset.sleekLeadConfirmed })) node.dataset.sleekReported = 'true';
    });
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-sleek-action]');
    if (target) publish('journey_action', { action: target.dataset.sleekAction, product_id: target.dataset.sleekProductId || context.product_id });
  });
  document.addEventListener('toggle', event => {
    const target = event.target;
    if (target.matches?.('details[data-sleek-detail]') && target.open) publish('product_detail_opened', { detail: target.dataset.sleekDetail });
  }, true);
  document.addEventListener('product:added', event => {
    const variant = event.detail?.variant;
    if (variant?.id) publish('cart_add_confirmed', { variant_id: String(variant.id) });
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.querySelector('[name="form_type"]')?.value !== 'contact') return;
    sourceFields(form);
    publish('project_request_submitted');
  });
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('shopify:section:load', sync);
  window.SleekJourney = { version: 'product-journey-v2', publish };
  if (privacy()) sync();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });
})();

/* Search suggestions: loads the suggestion dropdown (assets/sleek-search-suggest.js and .css) from the same asset folder. */
(() => {
  const me = document.currentScript;
  if (!me || !me.src) return;
  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = me.src.replace('sleek-journey.js', 'sleek-search-suggest.css');
  document.head.appendChild(css);
  const js = document.createElement('script');
  js.src = me.src.replace('sleek-journey.js', 'sleek-search-suggest.js');
  js.defer = true;
  document.head.appendChild(js);
})();

/* Homepage hero video: phones and tablets play a small 0.8 MB version right after the hero image shows. */
(() => {
  const video = document.querySelector('.sleek-home__hero-video');
  if (!video || !video.dataset.src) return;
  if (!window.matchMedia('(max-width: 989px)').matches) return;
  const conn = navigator.connection || {};
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '')) return;
  const small = 'https://cdn.shopify.com/s/files/1/0766/3540/6566/files/sleek-hero-mobile-720.mp4?v=1791694521';
  video.dataset.src = small;
  video.addEventListener('playing', () => video.classList.add('is-ready'), { once: true });
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    if (!video.querySelector('source') && !video.getAttribute('src')) {
      const source = document.createElement('source');
      source.src = small;
      source.type = 'video/mp4';
      video.appendChild(source);
      video.preload = 'auto';
      video.load();
    }
    const play = video.play();
    if (play && play.catch) play.catch(() => {});
  };
  const image = document.querySelector('.sleek-home__hero-fallback');
  if (!image || image.complete) start();
  else {
    image.addEventListener('load', start, { once: true });
    image.addEventListener('error', start, { once: true });
    setTimeout(start, 1500);
  }
})();
